import { render, staticRenderFns } from "./AddressBar.vue?vue&type=template&id=50d59f08&scoped=true"
import script from "./AddressBar.vue?vue&type=script&lang=js"
export * from "./AddressBar.vue?vue&type=script&lang=js"
import style0 from "./AddressBar.vue?vue&type=style&index=0&id=50d59f08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d59f08",
  null
  
)

export default component.exports